import * as React from 'react'

function SvgNavigationInstructionChecked(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path d="m32.293 8.293 1.414 1.414L28 15.414l-3.707-3.707 1.414-1.414L28 12.586l4.293-4.293Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 11c0-.338.019-.672.055-1H10a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h17a4 4 0 0 0 4-4v-6.223A9.033 9.033 0 0 1 29 20v6a2 2 0 0 1-2 2H15V12h5.055A9.098 9.098 0 0 1 20 11Zm-9 1v16h2V12h-2Z"
      />
      <path d="M18.242 15.636a4.623 4.623 0 0 1 2.336-1.456c.248.656.57 1.275.956 1.848-.803.098-1.379.452-1.776.914-.49.567-.758 1.357-.758 2.183 0 1.333.786 2.562 1.72 3.533.455.472.912.85 1.256 1.108l.024.018.024-.018c.344-.259.801-.636 1.255-1.108.935-.971 1.721-2.2 1.721-3.533v-.06a8.931 8.931 0 0 0 1.962.703c-.213 1.81-1.287 3.285-2.241 4.277a12.664 12.664 0 0 1-2.138 1.77l-.043.027-.012.008-.005.002-.001.001s-.002 0-.522-.853l-.52.854-.003-.002-.005-.002-.012-.008-.043-.027a11.183 11.183 0 0 1-.643-.45 12.664 12.664 0 0 1-1.495-1.32C18.214 22.938 17 21.23 17 19.125c0-1.236.398-2.51 1.242-3.489Z" />
      <path d="m21.48 25.854.52.317.52-.317L22 25l-.52.854ZM22 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
    </svg>
  )
}

export default SvgNavigationInstructionChecked
